
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import "react-quill/dist/quill.snow.css";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  Avatar,
  Tab,
  Tabs,
  Divider,
  CircularProgress,
  TextField,
  MenuItem,
  Chip,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Calendar from "./Calendar"; // Import Calendar component
import ViolationComments from "./ViolationComments";
import ViolationsTimeline from "./ViolationsTimeline"
import EditViolation from "./EditViolations"
import Notice from "./Coverletterssend"
import Visits from "./Visits"
import InfoIcon from "@mui/icons-material/Info";
import CategoryIcon from "@mui/icons-material/Category";
import HomeIcon from "@mui/icons-material/Home";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import CommentIcon from "@mui/icons-material/Comment";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import PersonIcon from "@mui/icons-material/Person"; // Import user icon

import { Dialog, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import api,{ API_BASE_URL } from "../../src/utils/api";

const ViolationsDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [violationDetails, setViolationDetails] = useState(null);
  const [member, setMember] = useState(null);
  const [noticeText, setNoticeText] = useState("");
  const [recipientEmail, setRecipientEmail] = useState("");
  const [activeTab, setActiveTab] = useState(0);
  const [violationType, setViolationType] = useState(""); 
  const [isLoading, setIsLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [templates, setTemplates] = useState([]); // Templates list
  const [selectedTemplate, setSelectedTemplate] = useState(""); // Selected template
  const [imageURL, setImageURL] = useState(null); // State for the fetched image
  const [openImageModal, setOpenImageModal] = useState(false);




  const currentUserId = localStorage.getItem("currentUserId") || 1; // Replace with real authentication logic
  console.log("Logged-in User ID:", currentUserId);

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const violationResp = await api.get(
          `/getViolation/${id}`
        );
        const violationData = violationResp.data;

        const memberResp = await api.get(
          `/members/${violationData.property_id}`
        );
        const memberData = memberResp.data;

        setViolationDetails(violationData);
        setMember(memberData);

        
        const templatesResp = await api.get(`/templates`);
        setTemplates(templatesResp.data);

        // Fetch the violation image
        if (violationData.upload_urls) {
          const sanitizedFilename = encodeURIComponent(violationData.upload_urls.trim());
          const imageResponse = `${API_BASE_URL}/violationsimages/${sanitizedFilename}`;
          console.log("Image URL:", imageResponse); // Debugging
          setImageURL(imageResponse);
        }
        
        console.log("Upload URLs:", violationDetails.upload_urls);
        if (violationData.ccr_violation_type_id) {
          const violationTypeResp = await api.get(
            `/getCcrViolationTypes`
          );
          const types = violationTypeResp.data;
          const type = types.find(
            (t) => t.id === violationData.ccr_violation_type_id
          );
          setViolationType(type ? type.title : "Type Not Found");
        }
        console.log("Violation Type ID:", violationData.ccr_violation_type_id);


        // Initialize the map with location if address is available
      
      } catch (error) {
        console.error("Failed to fetch data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchDetails();
  }, [id]);

 
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleTemplateChange = async (templateName) => {
    try {
      setSelectedTemplate(templateName);
      const response = await api.get(
        `/getTemplate/${templateName}`
      );
      setNoticeText(response.data.content); // Populate the notice editor
    } catch (error) {
      console.error("Failed to load template:", error);
    }
  };

  if (isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", marginTop: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!violationDetails || !member) {
    return (
      <Typography color="error" sx={{ textAlign: "center", marginTop: 4 }}>
        Failed to load data. Please try again later.
      </Typography>
    );
  }



  
  return (
    <Box sx={{ padding: 3 }}>
      <Button
        variant="outlined"
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate(-1)}
        sx={{ marginBottom: 3 }}
      >
        Back
      </Button>

      <Grid container spacing={3}>
        {/* Member Profile Section */}
        <Grid item xs={12} md={4}>
          <Card>
            <CardContent sx={{ textAlign: "center" }}>
              <Avatar
                src={`${API_BASE_URL}/images/${encodeURIComponent(
                  member.PhotoGraphicFileName?.trim() || ""
                )}`}
                alt={member.FirstName}
                sx={{
                  width: 120,
                  height: 120,
                  margin: "0 auto",
                  marginBottom: 2,
                  border: "4px solid #007bff",
                }}
              />
              <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                {`${member.FirstName} ${member.LastName}`}
              </Typography>
              <Typography
                variant="body1"
                color="textSecondary"
                sx={{ marginBottom: 3 }}
              >
                Member Code: {member.ClubMemberCode}
              </Typography>
              <Divider sx={{ marginY: 2 }} />
              <Typography variant="body2">
                <strong>Gender:</strong> {member.Gender}
              </Typography>
              <Typography variant="body2">
                <strong>Birth Date:</strong>{" "}
                {new Date(member.BirthDate).toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })}
              </Typography>
              <Typography variant="body2">
                <strong>Join Date:</strong>{" "}
                {new Date(member.JoinDate).toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })}
              </Typography>
              <Typography variant="body2">
                <strong>Status:</strong>{" "}
                <Chip
                  label={member.ClubStatusRuleCode}
                  color="success"
                  size="small"
                />
              </Typography>
              <Typography variant="body2">
                <strong>Address:</strong> {member.FullAddress || "N/A"}
              </Typography>
              <Divider sx={{ marginY: 2 }} />
              <Box
              />
               {/* Violation Timeline */}
      <Box sx={{ marginTop: 4 }}>
        <ViolationsTimeline violation_id={id} />
      </Box>
            </CardContent>
          </Card>

        </Grid>


        <Dialog open={openImageModal} onClose={() => setOpenImageModal(false)} maxWidth="md">
  <DialogContent sx={{ position: "relative", textAlign: "center" }}>
    <IconButton
      onClick={() => setOpenImageModal(false)}
      sx={{ position: "absolute", top: 8, right: 8 }}
    >
      <CloseIcon />
    </IconButton>
    <img
      src={imageURL}
      alt="Violation Evidence"
      style={{ width: "100%", maxHeight: "90vh", objectFit: "contain" }}
    />
  </DialogContent>
</Dialog>
        {/* Violation Details Section */}
        <Grid item xs={12} md={8}>
          <Card>
            <CardContent>
              <Tabs
                value={activeTab}
                onChange={handleTabChange}
                textColor="primary"
                indicatorColor="primary"
                variant="fullWidth"
                sx={{ marginBottom: 3 }}
              >
                <Tab label="Details" />
                <Tab label="Notice" />
                <Tab label="Calendar" />
                <Tab label="Comments" />
                <Tab label="Visits" />
              </Tabs>

              {/* Details Tab */}
              {activeTab === 0 && (
  <Box sx={{ position: "relative" }}>
    

    <Card
      sx={{
        width: "100%",
        maxWidth: "800px",
        padding: 3,
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        borderRadius: "12px",
        backgroundColor: "#ffffff",
      }}
    >
       {/* Violation Details Section */}
       <Typography variant="h5" sx={{ fontWeight: "bold", textAlign: "center", mb: 3 }}>
        Violation Details
      </Typography>
      <Divider sx={{ mb: 3 }} />
      
      {/* Image Section */}
{/* Image Section */}
{/* Three dots menu for editing status */}
<EditViolation
      violationDetails={violationDetails}
      onUpdate={(updatedData) => {
        setViolationDetails((prevDetails) => ({
          ...prevDetails,
          ...updatedData,
        }));
      }}
    />
{imageURL && (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      mb: 3,
    }}
  >
    <Card
      elevation={3}
      sx={{
        p: 2,
        borderRadius: "12px",
        backgroundColor: "#ffffff",
        boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)", // Stronger shadow for better contrast
        transition: "transform 0.3s ease-in-out",
        "&:hover": {
          transform: "scale(1.03)", // Subtle hover effect
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          overflow: "hidden",
          borderRadius: "12px",
        }}
        onClick={() => setOpenImageModal(true)}
      >
        <img
          src={imageURL}
          alt="Violation Evidence"
          style={{
            width: "100%",
            maxWidth: "200px", // Increased max-width for better balance
            height: "auto",
            borderRadius: "12px",
            border: "2px solid #ddd",
            boxShadow: "0 6px 12px rgba(0, 0, 0, 0.1)", // Better depth effect
            cursor: "pointer",
            transition: "transform 0.2s ease-in-out",
          }}
        />
      </Box>
      <Typography
        variant="body2"
        color="textSecondary"
        sx={{ mt: 1, textAlign: "center", fontStyle: "italic" }}
      >
        Click to enlarge
      </Typography>
    </Card>
  </Box>
)}


     

      {/* Details Card Grid */}
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Card sx={{ p: 2, display: "flex", alignItems: "center", gap: 2 }}>
            <InfoIcon color="primary" />
            <Typography variant="body2">
              <strong>Violation ID:</strong> VLT-{violationDetails.id}
            </Typography>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Card sx={{ p: 2, display: "flex", alignItems: "center", gap: 2 }}>
            <CategoryIcon color="secondary" />
            <Typography variant="body2">
              <strong>Type:</strong> {violationType || "N/A"}
            </Typography>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Card sx={{ p: 2, display: "flex", alignItems: "center", gap: 2 }}>
            <HomeIcon color="success" />
            <Typography variant="body2">
              <strong>Property ID:</strong> {violationDetails.property_id || "N/A"}
            </Typography>
          </Card>
        </Grid>

       

        <Grid item xs={12} sm={6}>
          <Card sx={{ p: 2, display: "flex", alignItems: "center", gap: 2 }}>
            <CalendarTodayIcon color="warning" />
            <Typography variant="body2">
              <strong>Violated At:</strong>{" "}
              {violationDetails.violated_at
                ? new Date(violationDetails.violated_at).toLocaleString()
                : "N/A"}
            </Typography>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6}>
  <Card sx={{ p: 2, display: "flex", alignItems: "center", gap: 2 }}>
    <PersonIcon color="info" /> {/* Change icon to User Icon */}
    <Typography variant="body2">
      <strong>Created By:</strong> {/* Update label */}
      {violationDetails.cure_by ? violationDetails.cure_by : "Unassigned"}
    </Typography>
  </Card>
</Grid>

        <Grid item xs={12}>
          <Card sx={{ p: 2, display: "flex", alignItems: "center", gap: 2 }}>
            <CommentIcon color="primary" />
            <Typography variant="body2">
              <strong>Comment:</strong> {violationDetails.comment || "N/A"}
            </Typography>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Card sx={{ p: 2, display: "flex", alignItems: "center", gap: 2 }}>
            <CheckCircleIcon color="success" />
            <Typography variant="body2">
              <strong>Status:</strong> {violationDetails.status || "N/A"}
            </Typography>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Card sx={{ p: 2, display: "flex", alignItems: "center", gap: 2 }}>
            <ReportProblemIcon color="error" />
            <Typography variant="body2">
              <strong>Created At:</strong>{" "}
              {violationDetails.created_at
                ? new Date(violationDetails.created_at).toLocaleString()
                : "N/A"}
            </Typography>
          </Card>
        </Grid>
      </Grid>

     
    </Card>
  </Box>
)}



{activeTab === 1 && (
  <Box>
    {member && violationDetails ? (
      <>
        {console.log("Tags passed to Notice:", {
          RecipientName: `${member.FirstName} ${member.LastName}`,
          RecipientAddress: member.FullAddress || "No Address",
          ViolationType: violationDetails.violationType || "N/A",
          ViolationID: `VLT-${violationDetails.id}` || "N/A",
          ViolationDate: violationDetails.violated_at 
            ? new Date(violationDetails.violated_at).toLocaleDateString("en-US") 
            : "N/A",
          CureByDate: violationDetails.cure_by 
            ? new Date(violationDetails.cure_by).toLocaleDateString("en-US") 
            : "N/A",
        })}

        <Notice
          tags={{
            RecipientName: `${member.FirstName} ${member.LastName}`,
            RecipientAddress: member.FullAddress || "No Address",
            ViolationType: violationType || "N/A",
            ViolationID: `VLT-${violationDetails.id}` || "N/A",
            ViolationDate: violationDetails.violated_at 
              ? new Date(violationDetails.violated_at).toLocaleDateString("en-US") 
              : "N/A",
            CureByDate: violationDetails.cure_by 
              ? new Date(violationDetails.cure_by).toLocaleDateString("en-US") 
              : "N/A",
          }}
          violation_id={violationDetails.id} 
        />
      </>
    ) : (
      <Typography variant="body2" color="error">
        Loading notice details...
      </Typography>
    )}
  </Box>
)}
              
              {activeTab === 2 && (
                <Box>
                  <Calendar
                    defaultView="month"
                    violation_id={id} // Pass the work order ID to the Calendar component
                    currentUserId={currentUserId}
                  />
                </Box>
              )}
              {/* Comments Tab */}         
              
              {/* Comments Tab */}
{activeTab === 3 && (
  <Box>
    <ViolationComments
      violation_id={id} // Pass the violation ID to the ViolationComments component
      currentUserId={currentUserId} // Pass the logged-in user ID to the component
    />
  </Box>
)}

{activeTab === 4 && (
  <Box>
    <Visits violation_id={id} currentUserId={currentUserId} />
  </Box>
)}



            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ViolationsDetails;
